import {Button} from "@progress/kendo-react-buttons"
import {useInternationalization} from "@progress/kendo-react-intl"
import {ListView, ListViewHeader, ListViewItemProps} from "@progress/kendo-react-listview"
import dayjs from "dayjs"
import {MDBSpinner} from "mdbreact"
import {Dispatch, SetStateAction} from "react"
import {useDispatch} from "react-redux"
import {Link, useLocation} from "react-router-dom"
import {RecentBooking} from "../../containers/App/models"
import {
    toggleTestDialog,
    setSelectedBookingId,
    NewBookingParams,
    setNewBookingDetail,
} from "../../containers/MotBooking/bookingSlice"
import {RootState} from "../../rootReducer"
import {useAppSelector} from "../../store"
import {calltoPreparerDealerName} from "../../utils/common"

const RecentBookingsList = ({
    vehicleRegNo,
    showSearchBox,
}: {
    vehicleRegNo: string
    showSearchBox: Dispatch<SetStateAction<boolean>>
}) => {
    const dispatch = useDispatch()
    const location = useLocation()

    const vehicleDetail = useAppSelector((state: RootState) => state.application.searchedVehicle)
    const bookings = useAppSelector((state: RootState) => state.application.recentBookings)
    const userDealers = useAppSelector((state: RootState) => state.application.userDealers)

    const selectedDealer = useAppSelector((state: RootState) => state.application.selectedSingleDealer)

    const toggleBookingDialog = (state: boolean) => {
        dispatch(toggleTestDialog(state))
    }
    const BookingHeader = () => {
        const loading = useAppSelector((state: RootState) => state.application.loadingRecentBookings)
        return (
            <ListViewHeader style={{color: "rgb(160, 160, 160)", fontSize: 14}}>
                <div className="d-flex justify-content-between align-items-center border-bottom pb-1 pt-1">
                    <h2 style={{fontSize: 12, color: "#434343", marginBottom: 0}} className="font-weight-bold">
                        Bookings
                    </h2>
                    <Button
                        type="button"
                        fillMode="link"
                        themeColor={"primary"}
                        size="small"
                        title="New booking"
                        iconClass="fa fa-plus"
                        onClick={() => {
                            const selectedPreparerDealerName = calltoPreparerDealerName(
                                userDealers,
                                selectedDealer?.dealerId,
                            )

                            let params = {
                                dealerId: selectedDealer?.dealerId,
                                testStart: dayjs().startOf("day").toDate().toString(),
                                testEnd: dayjs().startOf("day").toDate().toString(),
                                testPackageID: 0,
                                registration: vehicleDetail?.registration ?? "",
                                customer: null,
                                preparerDealerName:
                                    selectedPreparerDealerName !== undefined ? selectedPreparerDealerName : null,
                                preparedByDealer: selectedPreparerDealerName !== undefined ? true : false,
                            } as NewBookingParams
                            dispatch(setNewBookingDetail(params))
                            dispatch(setSelectedBookingId(0))
                            toggleBookingDialog(true)
                            showSearchBox(false)
                        }}
                    ></Button>
                </div>
                <div className="d-flex justify-content-around mb-2 mt-2">
                    {loading && (
                        <MDBSpinner role="status">
                            <span className="visually-hidden">Loading...</span>
                        </MDBSpinner>
                    )}
                    {vehicleDetail && !loading && bookings.length === 0 && (
                        <div style={{fontSize: 12, color: "#a0a0a0"}}>No data found</div>
                    )}
                </div>
            </ListViewHeader>
        )
    }

    const BookingItemRender = (props: ListViewItemProps) => {
        const intl = useInternationalization()
        let item = props.dataItem as RecentBooking
        return (
            <Link
                to={`${location.pathname}`}
                onClick={() => {
                    dispatch(setSelectedBookingId(item.bookingId))
                    toggleBookingDialog(true)
                    showSearchBox(false)
                }}
            >
                <div className="search-list-item align-middle border-bottom" style={{margin: 0}}>
                    <div className="d-flex justify-content-between align-items-center">
                        <div>{item.bookingRef}</div>
                        <div>
                            {intl.formatDate(new Date(item.testStart))} &nbsp;
                            {intl.formatDate(new Date(item.testStart), {time: "short"})}&nbsp; - &nbsp;
                            {intl.formatDate(new Date(item.testEnd), {time: "short"})}
                        </div>
                    </div>
                    <div className="font-weight-bold" style={{fontSize: 12, color: "#a0a0a0"}}>
                        {item.status}
                    </div>
                </div>
            </Link>
        )
    }

    return (
        <>
            <ListView
                data={bookings}
                item={BookingItemRender}
                style={{width: "100%", minHeight: "300px"}}
                header={BookingHeader}
            />
        </>
    )
}

export default RecentBookingsList
